import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const RewardIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M10.832 14.115V15.8333H14.9987V17.5H4.9987V15.8333H9.16536V14.115C7.55428 13.9118 6.07271 13.1277 4.9987 11.9098C3.92469 10.6919 3.33206 9.12384 3.33203 7.5V2.5H16.6654V7.5C16.6653 9.12384 16.0727 10.6919 14.9987 11.9098C13.9247 13.1277 12.4431 13.9118 10.832 14.115ZM4.9987 4.16667V7.5C4.9987 8.82608 5.52548 10.0979 6.46316 11.0355C7.40085 11.9732 8.67261 12.5 9.9987 12.5C11.3248 12.5 12.5965 11.9732 13.5342 11.0355C14.4719 10.0979 14.9987 8.82608 14.9987 7.5V4.16667H4.9987ZM0.832031 4.16667H2.4987V7.5H0.832031V4.16667ZM17.4987 4.16667H19.1654V7.5H17.4987V4.16667Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default RewardIcon;
